module.exports = __webpack_public_path__ + "static/assets/66a613e869e2913719f14338b88ef84d.png";